// extracted by mini-css-extract-plugin
module.exports = {"cross":"aag_aah"};